import React, { useContext, useState } from "react";

import { Menu, MenuItem, Tab, Tabs } from "@material-ui/core";

import { Button, Paper, TabPanel } from "../../../../../common/components/libs";
import PageStoreContext from "../context";
import { localize } from "../../../../../common/libs";
import { observer } from "mobx-react";
import PeriodsTab from "./periodsTab";
import CustomTab from "./customTab";
import AggregationIntervals from "./AggregationIntevals";
import { useStores } from "../../../../../hooks";
import { SnackbarType } from "../../../../../stores/common";
import {Trans, useTranslation} from "react-i18next";


const Filter = () => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [menuSelectorAnchorEl, setMenuSelectorAnchorEl] = useState<HTMLElement | null>(null);
    const pageStore = useContext(PageStoreContext);
    const [currentTab, setCurrentTab] = React.useState(0);
    const {generalStore} = useStores();
    const {i18n, t} = useTranslation(["general", "stats"]);
    const locale = i18n.language;


    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOpenMenuSelectorMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setMenuSelectorAnchorEl(event.currentTarget);
    };

    /*const setNewTimeInterval = (periodOption: IPeriodOptions) => {
        pageStore.setTimeInterval(
            periodOption.from,
            periodOption.to
        );
        setTitle(periodOption.title);
        setAnchorEl(null);
    }

    useEffect(() => {
        pageStore.setTimeInterval(
            periodOptions[0].from,
            periodOptions[0].to
        );
        setTitle(periodOptions[0].title);
    }, []);*/


    const setMenu = (menuId: number) => {
        pageStore.setMenu(menuId);
        setMenuSelectorAnchorEl(null);
        generalStore.showSnackbar({
            type: SnackbarType.success,
            title: t("general:labelOfUpdating")
        })
    };


    const handleTabChange = (event: React.ChangeEvent<{}>, newValue: 0 | 1) => {
        setCurrentTab(newValue);
        pageStore.setMode(newValue)
    };


    if(!pageStore.currentMenu) return null;
    return (
        <React.Fragment>
            {/*<SmallButton size="small" mr={2}>
                <LoopIcon/>
            </SmallButton>*/}
            {/*<SmallButton size="small" mr={2}>
          <FilterListIcon />
        </SmallButton>*/}


            <Button
                variant="contained"
                aria-owns={menuSelectorAnchorEl ? "menu-selector" : undefined}
                aria-haspopup="true"
                onClick={handleOpenMenuSelectorMenu}
                mr={5}
            >
                {localize(pageStore.currentMenu.data.name)}
            </Button>
            <Menu
                id="menu-selector"
                anchorEl={menuSelectorAnchorEl}
                open={Boolean(menuSelectorAnchorEl)}
                onClose={() => setMenuSelectorAnchorEl(null)}
            >
                {
                    pageStore.menusList.map(item => {
                        return <MenuItem
                            key={item.id}
                            onClick={() => {
                                setMenu(item.id);
                            }}
                        >
                            {localize(item.data.name)}
                        </MenuItem>
                    })
                }
            </Menu>
            <Button
                variant="contained"
                aria-owns={anchorEl ? "simple-menu" : undefined}
                aria-haspopup="true"
                color='secondary'
                onClick={handleOpenMenu}
            >
                {pageStore.getTitle(t)}
            </Button>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                getContentAnchorEl={null}
            >
                <Paper p={2} style={{
                    outline: "none"
                }}>
                    <Tabs
                        value={currentTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleTabChange}
                        variant="fullWidth"
                    >
                        <Tab label={t("stats:periods")}/>
                        <Tab label={t("stats:arbitrarily")} />
                    </Tabs>
                    <TabPanel value={currentTab} index={0}>
                        <PeriodsTab/>
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <CustomTab/>
                    </TabPanel>

                    {/*{
                        periodOptions.map(item => {
                            return <MenuItem
                                key={item.title}
                                onClick={() => {
                                    setNewTimeInterval(item);
                                }}
                            >
                                {item.title}
                            </MenuItem>
                        })
                    }*/}
                    <AggregationIntervals/>
                </Paper>
            </Menu>

        </React.Fragment>
    );
};


export default observer(Filter);
